module.exports = __webpack_public_path__ + "r-v3/img/mic_off.6cf49ca5.svg";